import { createActionFactory } from '../../common/redux';
const { createAction, createApiFailureAction } = createActionFactory('Experience Workspace => experience insights => ');

//=============================================
// BOOTSTRAP PHASE
//=============================================
const bootstrapExperienceInsights = createAction('bootstrap experience insights', experienceId => ({ experienceId }));
const bootstrapExperienceInsightsSuccess = createAction('successfully bootstraped experience insights');
const bootstrapExperienceInsightsFailure = createApiFailureAction('failed to bootstrap experience insights');

//=============================================
// GET EXPERIENCE TOTALS
//=============================================
const fetchExperienceTotals = createAction('fetch experience totals', experienceId => ({ experienceId }));
const fetchExperienceTotalsSuccess = createAction('successfully fetched experience totals', (experienceId, totals) => ({
  experienceId,
  totals,
}));
const fetchExperienceTotalsFailure = createApiFailureAction('failed to fetch experience totals');

export default {
  bootstrapExperienceInsights,
  bootstrapExperienceInsightsSuccess,
  bootstrapExperienceInsightsFailure,

  fetchExperienceTotals,
  fetchExperienceTotalsSuccess,
  fetchExperienceTotalsFailure,
};
